import { DropdownMenu, Icon, IconName } from '@usealloy/component-library';

export const RowHeaderDropdownMenu = ({
  disabled,
  disableDeleteRow,
  isOpen,
  onOpenChange,
  onDeleteRow,
  onInsertBefore,
  onInsertAfter,
}: {
  disabled: boolean;
  disableDeleteRow: boolean;
  isOpen: boolean;
  onOpenChange: (isOpen: boolean) => void;
  onDeleteRow: () => void;
  onInsertBefore: () => void;
  onInsertAfter: () => void;
}) => (
  <DropdownMenu
    align="start"
    disabled={disabled}
    onOpenChange={onOpenChange}
    isOpen={isOpen}
    trigger={(<div />)}
  >
    <DropdownMenu.Item
      style={{ width: 278 }}
      onClick={onInsertBefore}
    >
      <Icon icon={IconName.ArrowUp} />
      Insert 1 Row Above
    </DropdownMenu.Item>
    <DropdownMenu.Item
      style={{ width: 278 }}
      onClick={onInsertAfter}
    >
      <Icon icon={IconName.ArrowDown} />
      Insert 1 Row Below
    </DropdownMenu.Item>
    {!disableDeleteRow && (
      <DropdownMenu.Item
        style={{ color: 'var(--cl-text-error)', width: 278 }}
        onClick={onDeleteRow}
      >
        <Icon icon={IconName.Trash} color="var(--cl-text-error)" />
        Delete Row
      </DropdownMenu.Item>
    )}
  </DropdownMenu>
);
